import { render, staticRenderFns } from "./YesNot.vue?vue&type=template&id=052b7633&"
import script from "./YesNot.vue?vue&type=script&lang=js&"
export * from "./YesNot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports